
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M94.3 108.1c-21.8 3.6-41.6 21.3-48.6 43.4l-2.2 7V265c0 95.6.2 107.5 1.7 116.5 8.3 48.7 32.1 72.4 82.3 82 18.6 3.6 34.1 4.7 73.6 5.2 92.1 1.2 129.8-6.6 155.4-32.2 15.3-15.3 23.3-35.7 26.1-66.3l.7-7.2h12.1c21 0 32.9-3 45.1-11.2 4.1-2.7 9.7-7.5 12.5-10.6 6.1-6.8 13.4-21.2 15-29.7.8-4.1 1-19.8.8-48.5l-.3-42.5-2.6-6.7c-7.4-19-20.9-32.5-39.7-39.6-6-2.3-8.4-2.6-24.4-3l-17.7-.4-.6-4.6c-2.3-18.7-7.2-29.1-18.9-40.7-6-5.9-10.1-9-15.6-11.7-14.4-7-10-6.8-136.2-6.7-62.3.1-115.6.5-118.5 1m235.3 43.6c5.2 2.8 9 7.2 10.4 12.1 1.4 5.2 1.4 189.2-.1 203.7-3.4 33.4-12.8 45.5-40.9 52.4-22.1 5.4-67.4 7.9-112.5 6.2-49-1.9-72.5-7-85.3-18.6-7-6.3-11.7-18.1-14.3-36-1.5-10.3-2.5-184.6-1.1-199.2.8-8.7 1.3-10.8 3.6-13.7 4.4-5.9 8.2-7.9 16-8.7 3.9-.4 55-.6 113.6-.5l106.5.1zm81.2 62.5c3.3.8 6 2.5 9.3 5.8 6.9 6.9 7.1 8.9 6.7 50.1l-.3 34.6-3 4.8c-2.2 3.6-4.5 5.7-8.4 7.7-5 2.6-6.1 2.8-18.2 2.8H384V213h11.1c6 0 13.1.5 15.7 1.2"}})])
          )
        }
      }
    